import React from 'react';

export function ChevronIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d="M3 6.5L10 13.5L17 6.5"
        stroke="#FEFEFE"
        stroke-width="0.943655"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
